import { Button, Modal, Spinner } from "flowbite-react"
import { FaSpinner } from "react-icons/fa"

type Props = {
    show?: boolean
}

export default function SpinnerComponent({ show }: Props) {
    return (
        <>
            {show == true && (
                <>
                    <div className="fixed inset-0 flex justify-center items-center" style={{zIndex: 51}}>
                        <div className="w-12 h-12 flex justify-center items-center bg-gray-900 bg-opacity-50 rounded-full">
                            <Spinner aria-label="Extra large spinner example" size="xl" />
                        </div>
                    </div>

                </>
            )}
        </>
    )
}